import { Grid } from "@mui/material";
import React from "react";
import TwoColsDisplayProps from "./TwoColsDisplayProps.type";
import { defaultFonts } from "../../../helpers/fonts";
import styled from "@emotion/styled";
import breakpoints from "../../../helpers/breakpoint";

const ResponsiveContainer = styled.div({
  display: "flex",
  flexDirection: "row",
  justifyContent: "flex-start",
  alignItems: "flex-start",
  fontFamily: defaultFonts,
  "@media (max-width: 768px)": {
    alignItems: "center",
    flexDirection: "column",
  },
  width: "100%",
});

const ColumnContainer = styled.div({
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
  width: "50%"
});

const ItemContainer = styled.div({
    paddingTop: "5px",
    paddingLeft: "5px",
    textOverflow: "ellipsis",
    overflow:"hidden",
    whiteSpace: "nowrap",
    maxWidth: "100%",
    ":hover": {
        overflow: "visible", 
        whiteSpace: "normal",
        wordBreak: "break-word",
        height: "auto",
    }
})

const TwoColsDisplay = (props: TwoColsDisplayProps) => {
  return (
    <ResponsiveContainer>
      <ColumnContainer>
        {props.rows.map((row, i) => {
          return <ItemContainer key={"row-"+i}>{row.col1.displayData}</ItemContainer>;
        })}
      </ColumnContainer>
      <ColumnContainer>
        {props.rows.map((row, i) => {
          return <ItemContainer key={"row-"+i}>{row.col2.displayData}</ItemContainer>;
        })}
      </ColumnContainer>
    </ResponsiveContainer>
  );
};

export default TwoColsDisplay;
